import { client } from "../../utils";
import Prismic from "prismic-javascript";

export const fetchEvents = filters => dispatch => {
  client
    .query(Prismic.Predicates.at("document.type", "event"), {
      orderings: "[my.event.date desc]",
      ...filters
    })
    .then(res => {
      dispatch({
        type: "FETCH_EVENTS",
        payload: res
      });
    });
};

export const fetchEvent = uid => dispatch => {
  client.getByUID("event", uid).then(res => {
    dispatch({
      type: "FETCH_EVENT",
      payload: res
    });
  });
};

export const setEventLoading = () => {
  return {
    type: "EVENT_LOADING"
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/eventActions.js